import { render, staticRenderFns } from "./FormCheckbox.vue?vue&type=template&id=b6527d5e&scoped=true&"
import script from "./FormCheckbox.vue?vue&type=script&lang=js&"
export * from "./FormCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./FormCheckbox.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FormCheckbox.vue?vue&type=style&index=1&id=b6527d5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6527d5e",
  null
  
)

export default component.exports